module.exports = __webpack_public_path__ + "f5504c64d79cd9270034813b13941b2b.svg";